import React, { Component, useEffect, useState } from "react";
// import Table from "components/Table/Table.js";
import Button from "components/CustomButtons/Button.js";
import axios from "axios";
import Constants from "../variables/Constants";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Link } from "react-router-dom";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import AddAlert from "@material-ui/icons/AddAlert";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
// import Select from "@material-ui/core/Select";
import Modal from "react-awesome-modal";

// import MenuItem from "@material-ui/core/MenuItem";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import styles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import InputLabel from "@material-ui/core/InputLabel";
import Loader from "components/Loader";
// import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
// import { IconButton } from "@material-ui/core";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  Avatar,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoIcon from "@material-ui/icons/Info";
import TocIcon from "@material-ui/icons/Toc";

const classes = makeStyles(styles);
const perPages = ["10", "25", "50", "100"];

const Archive = () => {
  const [notifyStatus, setNotifyStatus] = useState(false);
  const [notifyStockStatus, setNotifyStockStatus] = useState(false);
  const [seqLoading, setSeqLoading] = useState(false);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [deleteCourseId, setDeleteCourseId] = useState(null);

  const [notifyNote, setNotifyNote] = useState(false);
  const [ord, setOrd] = useState(true);
  const [levels, setLevels] = useState([]);
  const [streams, setStreams] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [sequenceArray, setSequenceArray] = useState([]);
  const [category, setCategory] = useState("");
  const [sequence, setSequence] = useState("");
  const [faculty, setFaculty] = useState(false);
  const [warn, setWarn] = useState(false);
  const [add, setAdd] = useState(false);
  const [level, setLevel] = useState("");
  const [stream, setStream] = useState("");
  const [subject, setSubject] = useState("");
  const [secondaryCategories, setSecondaryCategories] = useState([]);
  const [facultyArr, setFacultyArr] = useState([]);
  const [status, setStatus] = useState("");
  const [active, setActive] = useState(1);
  const [productId, setProductId] = useState(0);
  const [price, setPrice] = useState("");
  const [perPage, setPerPage] = useState("10");
  const [currentPage, setCurrentPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [nextPage, setNextPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [lastPageView, setLastPageView] = useState(false);
  const [firstPageView, setFirstPageView] = useState(false);
  const [isFacultyDialogOpen, setIsFacultyDialogOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [total, setTotal] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [fromInc, setFromInc] = useState(1);
  const [toInc, setToInc] = useState(5);
  const [btnIdArray, setBtnIdArray] = useState([]);
  const [filteredBtnIdArray, setFilteredBtnIdArray] = useState([]);
  const [projectCourseStatus, setProjectCourseStatus] = useState("");
  const [notifyProject, setNotifyProject] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [visibleReplica, setVisibleReplica] = useState(false);
  const [replicaId, setReplicaId] = useState("");
  const [notification, setNotification] = useState(false);
  const [message, setMessage] = useState("");
  const [attempts, setAttempts] = useState([]);
  const [attemptId, setAttemptId] = useState("");
  const [language, setLanguage] = useState("");
  const [applyFilter, setApplyFilter] = useState(false);
  const [ftofbatch, setFtofbatch] = useState("");
  const [courseid, setCourseid] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false); // State just for the modal visibility

  const history = useHistory();
  const getCourses = async () => {
    try {
      const response = await axios.get(
        `${Constants.getUrls.getCourses}?type=COURSES&per_page=${perPage}&attempt_id=${attemptId}&lang=${language}&category_id=${category}&level_id=${level}&stream_id=${stream}&subject_id=${subject}`
      );

      const data = response.data;
      console.log("COURSES DATAAA", data);

      const btnIds = Array.from({ length: data.last_page }, (_, i) => i + 1);
      const sequences = data.data.map((v) => parseInt(v.SEQUENCE));

      setBtnIdArray(btnIds);
      setSequenceArray(sequences);
      setSecondaryCategories(data.data);
      setTotal(data.total);
      setFrom(data.from);
      setTo(data.to);

      const filtered = btnIds.filter((v) => v >= fromInc && v <= toInc);
      setFilteredBtnIdArray(filtered);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const getActiveAttempts = async () => {
    try {
      const response = await axios.get(
        "https://admin.akclasses.in/api/activeAttempts"
      );
      console.log("ACTIVE ATTEMPTS", response);
      setAttempts(response.data);
    } catch (error) {
      console.error("Error fetching active attempts:", error);
    }
  };

  const getCoursesCategory = async () => {
    try {
      const response = await axios.get(Constants.getUrls.courseCategoriesR);
      if (response) {
        console.log("Category COURSES Data", response?.data);
        setCategories(response?.data);
      }
    } catch (error) {
      console.error("Error fetching courses categories:", error);
    }
  };

  const handleFtofbatch = async (cid, fid) => {
    try {
      console.log(cid, fid);
      setCourseid(cid);
      setFtofbatch(fid);

      const payload = {
        courseid: cid,
        ftofbatch: fid,
      };

      const response = await axios.post(
        Constants.postUrls.add_ftofbatch,
        payload
      );
      console.log(response);

      getCourses(); // call your course fetching function
    } catch (error) {
      console.error("Error in handleFtofbatch:", error);
    }
  };

  const handlePage = async (e) => {
    try {
      const { name, value } = e.target;
      setPerPage(value);

      setFromInc(1);
      setToInc(5);
      setActive(1);
      //if (name === "per_page") {
      //  setPerPage(value);
      //}
      //   setState((prev) => ({
      //     ...prev,
      //     [name]: value
      //   }));

      const response = await axios.get(
        `https://admin.akclasses.in/api/courses?type=COURSES&per_page=${value}`
      );

      const btnIdArray = [];
      for (let i = 1; i <= response.data.last_page; i++) {
        btnIdArray.push(i);
      }

      const sequenceArray = response.data.data.map((v) => parseInt(v.SEQUENCE));

      setBtnIdArray(btnIdArray);
      setSequenceArray(sequenceArray);
      setOrd(true);
      setSecondaryCategories(response.data.data);
      setTotal(response.data.total);
      setFrom(response.data.from);
      setTo(response.data.to);

      const filtered = btnIdArray.filter((v) => v >= 1 && v <= 5);
      setFilteredBtnIdArray(filtered);
    } catch (error) {
      console.error("Error in handlePage:", error);
    }
  };

  const handleFacultyModal = async (id) => {
    try {
      setProductId(id);
      setFaculty(true);

      const response = await axios.get(
        `https://admin.akclasses.in/api/facultydetail?product_id=${id}`
      );

      setFacultyArr(response.data);
      setIsFacultyDialogOpen(true);
    } catch (error) {
      console.error("Error fetching faculty details:", error);
    }
  };

  const handleCancel = () => {
    setIsFacultyDialogOpen(false);
    setFacultyArr([]);
  };
  // const handleSequenceModal = (id, value, seq) => {
  //   if (value === "Add") {
  //     setAdd(true);
  //     setSequence("");
  //   } else {
  //     setAdd(false);
  //     setSequence(seq);
  //   }
  //   setProductId(id);
  //   setFaculty(false);
  //   setVisible(true);
  // };
  const handleSequenceModal = (id, action, value) => {
    console.log("Modal Triggered", { id, action, value }); // Debugging line
    setProductId(id);
    setSequence(value);
    setAdd(action === "Add");
    setIsModalVisible(true); // Use the new state to show the modal
  };

  // Add Sequence Logic
  const addSequence = async () => {
    console.log("Adding Sequence:", { sequence, productId });

    if (sequenceArray.includes(parseInt(sequence))) {
      console.log("Sequence Already Assigned");
      setWarn(true);
      setTimeout(() => setWarn(false), 2000);
    } else {
      try {
        setSeqLoading(true);
        setWarn(false);

        const seqArray = [
          {
            id: productId, // Ensure this is the product ID
            sequence: parseInt(sequence), // Ensure the sequence is a number
          },
        ];

        const response = await axios.post(
          "https://admin.akclasses.in/api/add_sequence",
          {
            products_sequence: seqArray,
          }
        );

        console.log("Add Sequence Response:", response);

        setNotifyNote(true);
        setSeqLoading(false);
        getCourses(); // Refresh data after successful add
        setTimeout(() => {
          setNotifyNote(false);
        }, 2000);
      } catch (error) {
        console.error("Error adding sequence:", error);
        setSeqLoading(false);
      }
    }
  };

  const updateSequence = async () => {
    const parsedSeq = parseInt(sequence);

    // Check if the sequence already exists for a different product
    const existingEntry = secondaryCategories.find(
      (item) => parseInt(item.SEQUENCE) === parsedSeq
    );

    if (existingEntry && existingEntry.ID !== productId) {
      setWarn(true);
      setTimeout(() => setWarn(false), 2000);
      return;
    }

    try {
      setSeqLoading(true);
      setWarn(false);

      const seqArray = [
        {
          id: productId,
          sequence: parsedSeq,
        },
      ];

      const response = await axios.post(
        "https://admin.akclasses.in/api/add_sequence",
        {
          products_sequence: seqArray,
        }
      );

      console.log("Update Sequence Response:", response);

      setNotifyNote(true);
      setSeqLoading(false);
      getCourses(); // Refresh data after successful update
      setTimeout(() => {
        setNotifyNote(false);
      }, 3000);
    } catch (error) {
      console.error("Error updating sequence:", error);
      setSeqLoading(false);
    }
  };

  // Handle Submit Logic for the Modal
  const handleSequenceSubmit = () => {
    console.log("Submitting sequence:", { productId, sequence, add });
    if (add) {
      addSequence();
    } else {
      updateSequence();
    }
    setTimeout(() => {
      setIsModalVisible(false);
    }, 2000);
  };

  // Cancel button should also close the modal
  // Removed floating JSX element

  const currentPages = async (v) => {
    try {
      const commonUrl = ord
        ? `https://admin.akclasses.in/api/courses?type=COURSES&per_page=${perPage}&page=`
        : `https://admin.akclasses.in/api/get_by_cate_levl_strm?per_page=${perPage}&category_id=${category}&level_id=${level}&stream_id=${stream}&page=`;

      const response = await axios.get(commonUrl + v);
      const objToArray = Object.entries(response.data?.data).map((obj) => ({
        key_name: obj[1],
      }));

      const newSecondaryCategories = objToArray.map((sec) => sec.key_name);
      setSecondaryCategories(newSecondaryCategories);

      setTotal(response.data.total);
      setFrom(response.data.from);
      setTo(response.data.to);
      setActive(v);
    } catch (error) {
      console.error("Error fetching page data:", error);
    }
  };

  const prevPages = () => {
    let newFromInc = fromInc - 5;
    let newToInc = toInc - 5;

    const filtered = btnIdArray.filter((v) => v >= newFromInc && v <= newToInc);

    const adjustWindow = (increment) => {
      const adjustedFrom = newFromInc + increment;
      const adjustedTo = newToInc + increment;
      const adjustedFiltered = btnIdArray.filter(
        (v) => v >= adjustedFrom && v <= adjustedTo
      );
      setFromInc(adjustedFrom);
      setToInc(adjustedTo);
      setFilteredBtnIdArray(adjustedFiltered);
    };

    if (filtered.length >= 1) {
      switch (filtered.length) {
        case 1:
          adjustWindow(4);
          break;
        case 2:
          adjustWindow(3);
          break;
        case 3:
          adjustWindow(2);
          break;
        case 4:
          adjustWindow(1);
          break;
        default:
          setFromInc(newFromInc);
          setToInc(newToInc);
          setFilteredBtnIdArray(filtered);
          break;
      }
    } else {
      const resetFrom = fromInc;
      const resetTo = toInc;
      const filtered = btnIdArray.filter((v) => v >= resetFrom && v <= resetTo);
      setFilteredBtnIdArray(filtered);
    }
  };

  const nextPages = () => {
    const newFromInc = fromInc + 5;
    const newToInc = toInc + 5;
    const filtered = btnIdArray.filter((v) => v >= newFromInc && v <= newToInc);

    const adjustWindow = (decrement) => {
      const adjustedFrom = newFromInc - decrement;
      const adjustedTo = newToInc - decrement;
      const adjustedFiltered = btnIdArray.filter(
        (v) => v >= adjustedFrom && v <= adjustedTo
      );
      setFromInc(adjustedFrom);
      setToInc(adjustedTo);
      setFilteredBtnIdArray(adjustedFiltered);
    };

    if (filtered.length >= 1) {
      switch (filtered.length) {
        case 1:
          adjustWindow(4);
          break;
        case 2:
          adjustWindow(3);
          break;
        case 3:
          adjustWindow(2);
          break;
        case 4:
          adjustWindow(1);
          break;
        default:
          setFromInc(newFromInc);
          setToInc(newToInc);
          setFilteredBtnIdArray(filtered);
          break;
      }
    } else {
      const resetFrom = fromInc;
      const resetTo = toInc;
      const filtered = btnIdArray.filter((v) => v >= resetFrom && v <= resetTo);
      setFilteredBtnIdArray(filtered);
    }
  };

  const handleSelect = async (e, id) => {
    const { name, value } = e.target;
    const updatedStatus = { ...status, [name]: value };
    setStatus(updatedStatus); // assuming `status` is a state

    try {
      await axios.post(`https://admin.akclasses.in/api/course/status/${id}`, {
        status: value,
      });

      setNotifyStatus(true);
      setTimeout(() => {
        setNotifyStatus(false);
        setFromInc(1);
        setToInc(5);
        setActive(1);
        getCourses(); // assuming this is defined elsewhere
      }, 1000);
    } catch (err) {
      console.error("Failed to update status", err);
    }
  };

  const handleProjectVisibility = async (e, id) => {
    const value = e.target.value;

    try {
      const payload = { project_course_status: value };
      const response = await axios.post(
        `https://admin.akclasses.in/api/updateProjectStatus/${id}`,
        payload
      );
      console.log(response);

      setNotifyProject(true);
      setTimeout(() => {
        setNotifyProject(false);
        getCourses(); // Reload updated data
      }, 1000);
    } catch (err) {
      console.error("Failed to update project visibility", err);
    }
  };

  const handleStock = async (e, id) => {
    const value = e.target.value;
    try {
      await axios.post(
        `https://admin.akclasses.in/api/updateStockStatus/${id}`,
        {
          stock_status: value,
        }
      );
      setNotifyStockStatus(true);
      setTimeout(() => {
        setNotifyStockStatus(false);
        setFromInc(1);
        setToInc(5);
        setActive(1);
        getCourses(); // Assuming this is already defined elsewhere
      }, 1000);
    } catch (err) {
      console.error("Stock update failed", err);
    }
  };

  const handleLevel = async (e) => {
    const { name, value } = e.target;
    setCategory(value);
    setStreams([]); // clear streams

    try {
      const resp = await axios.get(
        `https://admin.akclasses.in/api/showCategory_with_level/${value}`
      );
      setLevels(resp.data.level);
      setLevel(""); // reset selected level
    } catch (err) {
      console.error("Failed to fetch levels", err);
    }
  };

  const handleStream = async (e) => {
    const { name, value } = e.target;
    setLevel(value); // assuming this sets the selected level

    try {
      const resp = await axios.get(
        `https://admin.akclasses.in/api/level/${value}`
      );
      setStreams(resp.data.stream);
      setStream(""); // reset stream
    } catch (err) {
      console.error("Failed to fetch streams", err);
    }
  };

  const handleSubject = async (e) => {
    const { name, value } = e.target;
    setStream(value);

    try {
      const resp = await axios.get(
        `https://admin.akclasses.in/api/getStreamsSubject?stream_id=${value}`
      );
      setSubjects(resp.data.data);
      setSubject(""); // reset subject
    } catch (err) {
      console.error("Failed to fetch subjects", err);
    }
  };

  const searchRecordOld = async () => {
    try {
      const response = await axios.get(
        `https://admin.akclasses.in/api/get_by_cate_levl_strm?per_page=${perPage}&attempt_id=${attemptId}&lang=${language}&category_id=${category}&level_id=${level}&stream_id=${stream}&subject_id=${subject}`
      );

      const btnIdArray = Array.from(
        { length: response.data.last_page },
        (_, i) => i + 1
      );
      const sequenceArray = response.data.data.map((v) => parseInt(v.SEQUENCE));

      setSecondaryCategories(response.data.data);
      setOrd(false);
      setBtnIdArray(btnIdArray);
      setSequenceArray(sequenceArray);
      setFromInc(1);
      setActive(1);
      setToInc(5);
      setTotal(response.data.total);
      setFrom(response.data.from);
      setTo(response.data.to);

      const filtered = btnIdArray.filter((v) => v >= 1 && v <= 5);
      setFilteredBtnIdArray(filtered);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const searchRecord = async () => {
    try {
      const response = await axios.get(
        `https://admin.akclasses.in/api/get_by_cate_levl_strm?per_page=${perPage}&attempt_id=${attemptId}&lang=${language}&category_id=${category}&level_id=${level}&stream_id=${stream}&subject_id=${subject}`
      );
      setSecondaryCategories(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateSpreadsheet = async (courseId) => {
    console.log(courseId);
    const payload = { course_id: courseId };

    try {
      const deleteRes = await axios.post(
        Constants.postUrls.deleteOrdersSheetData,
        payload
      );
      if (deleteRes.data.status === "success") {
        const updateRes = await axios.post(
          Constants.postUrls.updateOrdersSpreadsheet,
          payload
        );
        if (updateRes.data.status === "success") {
          setNotification(true);
          setMessage(updateRes.data.message);
          setTimeout(() => setNotification(false), 3000);
        }
      }
    } catch (error) {
      console.error("Error updating spreadsheet", error);
    }
  };

  const replicaConfirmation = (courseId) => {
    setVisibleReplica(true);
    setReplicaId(courseId);
  };

  const createReplica = async (replicaId) => {
    console.log(replicaId);
    const payload = { course_id: replicaId };
    try {
      const resp = await axios.post(Constants.postUrls.createReplica, payload);
      console.log(resp);
      if (resp.data.status === "success") {
        setVisibleReplica(false);
        getCourses(); // assuming getCourses is defined in the same scope
      }
    } catch (error) {
      console.error("Replica creation failed:", error);
    }
  };

  const handleDelete = (id) => {
    setVisibleDelete(true);
    setDeleteId(id);
  };

  // const deleteCourse = async () => {
  //   try {
  //     console.log(deleteId);
  //     const res = await axios.post(
  //       `${Constants.postUrls.deleteCourse}${deleteId}`
  //     );
  //     console.log(res);
  //     setVisibleDelete(false);
  //     getCourses();
  //   } catch (error) {
  //     console.error("Error deleting course:", error);
  //   }
  // };

  const handleIsFeatured = async (e, id) => {
    try {
      console.log(e.target.value);
      const payload = {
        is_featured: e.target.value,
        course_id: id,
      };
      const res = await axios.post(
        "https://admin.akclasses.in/api/courses/update_featured",
        payload
      );
      console.log(res);

      setNotification(true);
      setMessage("Course featured status updated!");

      setTimeout(() => {
        setNotification(false);
        getCourses();
      }, 1000);
    } catch (error) {
      console.error("Error updating featured status:", error);
    }
  };

  const handleActions = async (action, id) => {
    if (action === "edit") {
      // Use history.push to navigate
      history.push(`/admin/updatenewcoursemaster/${id}`);
    }

    if (action === "delete") {
      setDeleteCourseId(id);
      setVisibleDelete(true); // show modal
      // if (window.confirm("Are you sure you want to delete this course?")) {
      //   try {
      //     await axios.post(
      //       `https://admin.akclasses.in/api/course/delete/${id}`
      //     );
      //     console.log("Delete success");
      //     await getCourses(); // Fetch updated courses after delete
      //   } catch (error) {
      //     console.error("Error deleting course:", error);
      //     alert("Failed to delete course.");
      //   }
      // }
    }
  };

  const deleteCourse = async (id) => {
    try {
      await axios.post(`https://admin.akclasses.in/api/course/delete/${id}`);
      console.log("Delete success");
      await getCourses();
    } catch (error) {
      console.error("Error deleting course:", error);
      alert("Failed to delete course.");
    }
  };

  const getAttemptTitle = (id) => {
    const attempt = attempts.find((a) => a.id === id);
    return attempt?.title || "-";
  };

  useEffect(() => {
    getCourses();
    getActiveAttempts();
    getCoursesCategory();
  }, []);

  return (
    <div className=" ">
      <GridContainer>
        {notifyStatus && (
          <div style={{ position: "relative", left: "600px" }}>
            <SnackbarContent
              message={"Status Changed!"}
              icon={AddAlert}
              color="success"
            />
          </div>
        )}

        {notifyStockStatus && (
          <div style={{ position: "relative", left: "600px" }}>
            <SnackbarContent
              message={"Stock Status Changed!"}
              icon={AddAlert}
              color="success"
            />
          </div>
        )}

        {notification && (
          <div style={{ position: "relative", left: "600px" }}>
            <SnackbarContent
              message={message}
              icon={AddAlert}
              color="success"
            />
          </div>
        )}
        <GridItem xs={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="danger">
                <Assignment />
              </CardIcon>
              <h4>Simple Table</h4>
            </CardHeader>
            <CardBody style={{ position: "relative" }}>
              <FormControl
                style={{
                  position: "absolute",
                  right: "10%",
                  width: "85px",
                }}
                className={classes.selectFormControl}
              >
                <InputLabel
                  htmlFor="simple-select"
                  className={classes.selectLabel}
                >
                  Per Page
                </InputLabel>
                <Select
                  s
                  key={1}
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  classes={{
                    select: classes.select,
                  }}
                  value={perPage}
                  inputProps={{
                    name: "per_page",
                    id: "simple-select",
                    onChange: (e) => {
                      handlePage(e);
                    },
                  }}
                >
                  {perPages.map((v, i) => (
                    <MenuItem
                      key={i}
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                      value={v}
                    >
                      {v}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                onClick={() => {
                  setApplyFilter(!applyFilter);
                }}
                style={{
                  position: "relative",
                }}
                color="success"
              >
                {applyFilter === false ? "Apply Filter" : "Hide Filter"}
              </Button>
              {applyFilter && (
                <div>
                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      style={{ marginTop: "12px" }}
                      required
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="attempt-select"
                        className={classes.selectLabel}
                      >
                        Attempt
                      </InputLabel>
                      <Select
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        value={attemptId}
                        onChange={(e) => setAttemptId(e.target.value)}
                        inputProps={{ id: "attempt-select" }}
                      >
                        {attempts.map((v, i) => (
                          <MenuItem
                            key={i}
                            value={v?.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                          >
                            {v?.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      style={{ marginTop: "12px" }}
                      required
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="language-select"
                        className={classes.selectLabel}
                      >
                        Language
                      </InputLabel>
                      <Select
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                        inputProps={{ id: "language-select" }}
                      >
                        <MenuItem value="Hindi">Hindi</MenuItem>
                        <MenuItem value="English">English</MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      style={{ marginTop: "12px" }}
                      required
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="category-select"
                        className={classes.selectLabel}
                      >
                        Category
                      </InputLabel>
                      <Select
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        value={category}
                        onChange={handleLevel}
                        inputProps={{ id: "category-select" }}
                      >
                        {categories.map((v, i) => (
                          <MenuItem
                            key={i}
                            value={v.ID}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                          >
                            {v.CATEGORY}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      style={{ marginTop: "12px" }}
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="level-select"
                        className={classes.selectLabel}
                      >
                        Level
                      </InputLabel>
                      <Select
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        value={level}
                        onChange={handleStream}
                        inputProps={{ id: "level-select" }}
                      >
                        <MenuItem value="">Select Category First</MenuItem>
                        {levels.map((v, i) => (
                          <MenuItem
                            key={i}
                            value={v.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                          >
                            {v.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      style={{ marginTop: "12px" }}
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="stream-select"
                        className={classes.selectLabel}
                      >
                        Stream
                      </InputLabel>
                      <Select
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        value={stream}
                        onChange={handleSubject}
                        inputProps={{ id: "stream-select" }}
                      >
                        <MenuItem value="">Select Level First</MenuItem>
                        {streams.map((v, i) => (
                          <MenuItem
                            key={i}
                            value={v.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                          >
                            {v.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={4}>
                    <FormControl
                      style={{ marginTop: "12px" }}
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="subject-select"
                        className={classes.selectLabel}
                      >
                        Subject
                      </InputLabel>
                      <Select
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        inputProps={{ id: "subject-select" }}
                      >
                        <MenuItem value="">Select Stream First</MenuItem>
                        {subjects.map((v, i) => (
                          <MenuItem
                            key={i}
                            value={v.id}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                          >
                            {v.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>

                  <Button
                    onClick={getCourses}
                    style={{ position: "relative", left: "20%" }}
                    color="success"
                  >
                    Search
                  </Button>
                </div>
              )}
              <div>
                {/* <Link to="/admin/newaddcoursesmaster">
                  <Button className="" color="warning">
                    Add Courses Master
                  </Button>
                </Link> */}
                {/* <Button className="flex justify-end" color="warning">
                  Archive
                </Button> */}
                <Paper elevation={3} style={{ overflowX: "auto" }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Course Title</TableCell>
                        <TableCell>Course Id</TableCell>
                        <TableCell>Price</TableCell>
                        <TableCell>Duration</TableCell>
                        <TableCell>Attempt</TableCell>
                        <TableCell>Batches</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Is Featured</TableCell>
                        <TableCell>Image</TableCell>
                        <TableCell>Sequence</TableCell>
                        <TableCell>Faculty</TableCell>
                        <TableCell>Update</TableCell>
                        <TableCell>Action </TableCell>
                        <TableCell>Replica</TableCell>
                        <TableCell>Strategy</TableCell>
                        <TableCell>Projects</TableCell>
                        <TableCell>Stock Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {secondaryCategories?.map((row, index) => (
                        <TableRow hover key={index}>
                          <TableCell> {index + 1} </TableCell>
                          <TableCell> {row?.TITLE}</TableCell>
                          <TableCell> {row?.ID}</TableCell>
                          <TableCell>
                            {" "}
                            ₹{row?.variant?.[0]?.price || "-"}
                          </TableCell>
                          <TableCell>{row?.DURATION || "-"}</TableCell>
                          <TableCell>
                            {" "}
                            {getAttemptTitle(row.variant?.[0]?.attempt_id)}
                          </TableCell>
                          <TableCell>
                            {row?.course_batches &&
                            row?.course_batches.length > 0
                              ? row.course_batches
                                  .map(
                                    (courseBatch) =>
                                      courseBatch.batch?.batch_name
                                  )
                                  .join(", ")
                              : "No Batch"}
                          </TableCell>

                          <TableCell>
                            <Select
                              key={index}
                              value={row.STATUS}
                              classes={{
                                select: classes.select,
                              }}
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              inputProps={{
                                name: "status",
                                id: "simple-select",
                                onChange: (e) => handleSelect(e, row.ID),
                              }}
                            >
                              <MenuItem
                                value="ACTIVE"
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                ACTIVE
                              </MenuItem>
                              <MenuItem
                                value="INACTIVE"
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                INACTIVE
                              </MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <Select
                              key={index}
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={row?.is_featured}
                              onChange={(e) => handleIsFeatured(e, row.ID)} // Functional call
                              inputProps={{
                                name: "project_course_status",
                                id: "simple-select",
                              }}
                            >
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                value="both"
                              >
                                BOTH
                              </MenuItem>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                value={1}
                              >
                                Featured
                              </MenuItem>
                              <MenuItem
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                                value={0}
                              >
                                Non Featured
                              </MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <img
                              src={`https://admin.akclasses.in/${row?.IMAGE_PATH}`}
                              alt={row?.TITLE}
                              style={{
                                width: "110px",
                                height: "auto",
                                objectFit: "cover",
                              }}
                            />
                          </TableCell>

                          <TableCell>
                            {row.SEQUENCE ? (
                              <Button
                                color="info"
                                onClick={() => {
                                  handleSequenceModal(
                                    row.ID,
                                    "Update",
                                    row.SEQUENCE
                                  ); // Update sequence
                                }}
                              >
                                {row.SEQUENCE}
                              </Button>
                            ) : (
                              <Tooltip
                                id="tooltip-top"
                                title="Add Sequence"
                                placement="top"
                                classes={{ tooltip: classes.tooltip }}
                              >
                                <IconButton
                                  aria-label="Sequence"
                                  className={classes.tableActionButton}
                                  onClick={() =>
                                    handleSequenceModal(row.ID, "Add", "")
                                  } // Add sequence
                                >
                                  <span className="material-icons">toc</span>
                                </IconButton>
                              </Tooltip>
                            )}
                          </TableCell>

                          <TableCell>
                            <Tooltip
                              id="tooltip-top"
                              title="Details"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <IconButton
                                aria-label="Details"
                                className={classes.tableActionButton}
                                onClick={() => handleFacultyModal(row.ID)}
                              >
                                <span className="material-icons">
                                  description
                                </span>
                              </IconButton>
                            </Tooltip>
                          </TableCell>

                          <TableCell>
                            <Tooltip title="Edit">
                              <IconButton
                                onClick={() => handleActions("edit", row.ID)}
                                color="primary"
                              >
                                <EditIcon />
                              </IconButton>
                            </Tooltip>

                            <Tooltip title="Details">
                              <IconButton
                                onClick={() => handleActions("details", row.id)}
                                color="default"
                              >
                                <InfoIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip title="Delete">
                              <IconButton
                                onClick={() => {
                                  handleActions("delete", row.ID);
                                }}
                                color="secondary"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              id="tooltip-top"
                              title="Add Replica"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <IconButton
                                aria-label="Add Replica"
                                className={classes.tableActionButton}
                                onClick={() => {
                                  replicaConfirmation(row.ID);
                                }}
                              >
                                <span className="material-icons">
                                  content_copy
                                </span>
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              id="tooltip-top"
                              title="Add Strategy"
                              placement="top"
                              classes={{ tooltip: classes.tooltip }}
                            >
                              <IconButton
                                aria-label="Add Strategy"
                                className={classes.tableActionButton}
                                onClick={() =>
                                  history.push(
                                    `/admin/addnewcoursestrategy/${row.ID}`
                                  )
                                }
                              >
                                <span className="material-icons">
                                  settings_input_composite
                                </span>
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Select
                              value={row.project_course_status}
                              onChange={(e) =>
                                handleProjectVisibility(e, row.ID)
                              }
                              inputProps={{
                                name: "project_course_status",
                                id: "simple-select",
                              }}
                              classes={{ select: classes.select }}
                              MenuProps={{ className: classes.selectMenu }}
                            >
                              <MenuItem
                                value="both"
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                BOTH
                              </MenuItem>
                              <MenuItem
                                value="ak1"
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                AK CLASSES
                              </MenuItem>
                              <MenuItem
                                value="ak2"
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                V SMART
                              </MenuItem>
                            </Select>
                          </TableCell>
                          <TableCell>
                            <Select
                              value={row.stock_status} // Use sec.stock_status for individual row value
                              onChange={(e) => handleStock(e, row.ID)} // Pass sec.ID to handleStock for the specific row
                              inputProps={{
                                name: "status",
                                id: "simple-select",
                              }}
                              classes={{ select: classes.select }}
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                            >
                              <MenuItem
                                value="1"
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                Out of Stock
                              </MenuItem>
                              <MenuItem
                                value="0"
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                In Stock
                              </MenuItem>
                            </Select>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <Modal
        visible={visibleDelete}
        width="435px"
        height="277px"
        effect="fadeInUp"
        onClickAway={() => setVisibleDelete(false)}
      >
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardBody>
                <div>
                  <h3>Are You Sure You Want to Delete It?</h3>
                  <div>
                    <GridItem xs={12} sm={12} md={4}>
                      <br />
                      <Button
                        color="danger"
                        onClick={() => {
                          setVisibleDelete(false);
                          deleteCourse(deleteCourseId); // call your existing function with ID
                        }}
                      >
                        Delete
                      </Button>
                      <Button
                        color="warning"
                        onClick={() => setVisibleDelete(false)}
                      >
                        Cancel
                      </Button>
                    </GridItem>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </Modal>

      <Modal
        visible={visibleReplica}
        width="500px"
        height="277px"
        effect="fadeInUp"
        onClickAway={() => setVisibleReplica(false)}
      >
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardBody>
                <div>
                  <h3>Are You Sure You Want to Make Replica?</h3>
                  <div>
                    <GridItem xs={12} sm={12} md={4}>
                      <br />
                      <Button
                        className=""
                        color="danger"
                        onClick={() => {
                          createReplica(replicaId);
                        }}
                      >
                        Yes
                      </Button>
                      <Button
                        className=""
                        color="warning"
                        onClick={() => {
                          setVisibleReplica(false);
                        }}
                      >
                        No
                      </Button>
                    </GridItem>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </Modal>
      <Modal
        visible={isModalVisible}
        width="1000px"
        height="330px"
        effect="fadeInUp"
        onClickAway={() => setIsModalVisible(false)} // Close modal when clicking outside
      >
        <h3>{add ? "Add Sequence" : "Update Sequence"}</h3>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="Sequence"
              id="float"
              inputProps={{
                value: sequence,
                type: "number",
                onChange: (e) => setSequence(e.target.value), // Set sequence state on input change
              }}
              formControlProps={{
                fullWidth: true,
              }}
            />
            {notifyNote && (
              <div>
                <span style={{ color: "green" }}>
                  Sequence {add ? "Added" : "Updated"} Successfully!
                </span>
              </div>
            )}
            {warn && (
              <div>
                <span style={{ color: "red" }}>Sequence Already Assigned!</span>
              </div>
            )}
          </GridItem>

          <GridItem xs={12} sm={12} md={4}>
            <br />
            <Button color="warning" onClick={handleSequenceSubmit}>
              {seqLoading ? <Loader /> : add ? "Add" : "Update"}
            </Button>
            <Button color="danger" onClick={() => setIsModalVisible(false)}>
              Cancel
            </Button>
          </GridItem>
        </GridContainer>
      </Modal>

      <Dialog
        open={isFacultyDialogOpen}
        onClose={handleCancel}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Faculty Details</DialogTitle>
        <DialogContent>
          {facultyArr.length > 0 ? (
            <>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px",
                  marginTop: "16px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }}
              >
                <thead style={{ backgroundColor: "#f5f5f5" }}>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "left",
                        fontWeight: "bold",
                      }}
                    >
                      Sr.No
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "left",
                        fontWeight: "bold",
                      }}
                    >
                      Name
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        textAlign: "left",
                        fontWeight: "bold",
                      }}
                    >
                      Share (%)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {facultyArr.map((sec, index) => (
                    <tr
                      key={sec.id}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                      }}
                    >
                      <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                        {index + 1}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                        {sec.name}
                      </td>
                      <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                        {sec.faculty_share}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <Button
                onClick={handleCancel}
                className="btn-round"
                color="error"
                variant="contained"
                style={{ marginTop: "16px" }}
              >
                Cancel
              </Button>
            </>
          ) : (
            <p>No faculty data available.</p>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Archive;
